<template>
  <dialogWrap
    v-model="show"

    :title="title"
    :width="'1000px'"
  >
    <div><span>收款起止日期：</span><span>{{`${effectDate || '-'}至${endDate || '-'}`}}</span></div>
    <FromMatching
      :BLMloading="loading"
      :totalData="paginationData.total"
      :tableData="SingleReceivableList"
      :headData="orderObj[orderType] ? orderObj[orderType].headData : headData"
      :pageEvent="paginationChange"
    >
    </FromMatching>
  </dialogWrap>
</template>

<script>
import { getDetailReceivable, paymentDetail } from '@/api/domain/orders.js'
import selectOption from '@/store/dict/selectOptionDict'

export default {
  model: {
    prop: 'SingleReceivableShow',
    event: 'change',
  },
  props: {
    SingleReceivableShow: {
      type: Boolean,
      default: false,
    },
    title: {
      type: String,
      default: '应收单预览',
    },
    orderType: {
      type: String,
      default: 'personal',
    },
    params: {
      type: Object,
      default: () => {},
    },
  },
  data() {
    return {
      show: false,
      loading: false,
      paginationData: {
        pageSize: 10,
        pageNum: 1,
        total: 0,
      },
      orderObj: {
        purchaseSonOrder: {
          headData: [
            {
              label: '期数',
              prop: 'index',
            },
            {
              label: '应付ID',
              prop: 'accruedId',
            },
            {
              label: '收款类型',
              prop: 'fundTypeName',
            },
            {
              label: '应付金额(元)',
              prop: 'paymentAmount',
            },
            {
              label: '款项周期',
              prop: 'accruedCycle',
              range: 106,
            },
            {
              label: '应付日期',
              prop: 'dueDate',
            },
            {
              label: '备注',
              prop: 'remarks',
              range: 120,
            },
            {
              label: '付款状态',
              prop: 'payState',
              event: (val) => {
                return selectOption.paymentStatusDict[val]
              },
            },
            {
              label: '付款完成时间',
              prop: 'completeTime',
              isfin: true,
            },
          ],
        },
      },
      headData: [
        {
          label: '期数',
          prop: 'index',
        },
        {
          label: '应收ID',
          prop: 'accruedId',
        },
        {
          label: '收款类型',
          prop: 'fundTypeName',
        },
        {
          label: '应收金额(元)',
          prop: 'planAmount',
        },
        {
          label: '款项周期',
          prop: 'accruedCycle',
          range: 106,
        },
        {
          label: '应收日期',
          prop: 'dueDate',
        },
        {
          label: '备注',
          prop: 'remarks',
          range: 120,
        },
        {
          label: '收款状态',
          prop: 'receivableState',
          event: (val) => {
            return selectOption.completionStatusDict[val]
          },
        },
        {
          label: '收款完成时间',
          prop: 'completeTime',
          isfin: true,
        },
      ],
      SingleReceivableList: [],
      effectDate: '',
      endDate: '',
    }
  },
  watch: {
    SingleReceivableShow(val) {
      this.show = val
      if (val) {
        this.orderId = Number(this.$route.query.id)
        this.getDetailReceivable()
      }
    },
    show(val) {
      this.$emit('change', val)
    },
  },
  methods: {
    paginationChange(pageSize, pageNum) {
      this.paginationData.pageSize = pageSize
      this.paginationData.pageNum = pageNum
      this.getDetailReceivable()
    },
    // 获取应收单详情
    getDetailReceivable() {
      const apiObj = {
        purchaseSonOrder: paymentDetail,
      }
      const api = apiObj[this.$route.query.orderType] || getDetailReceivable
      this.loading = true
      api({
        ...this.paginationData,
        orderId: this.orderId,
        fundType: this.params.mode,
        feeId: this.params.id,
      }).then((res) => {
        const { code, data } = res
        if (code === 1) {
          const { effectDate, endDate, payPlanDetail } = data
          const { items, totalNum } = payPlanDetail
          this.effectDate = effectDate
          this.endDate = endDate
          this.SingleReceivableList = items && items.map((item, index) => {
            item.index = (this.paginationData.pageNum - 1) * 10 + (index + 1)
            return item
          })
          this.paginationData.total = totalNum || 0
        }
        this.loading = false
      })
    },
  },
}
</script>

<style>

</style>
